import Repository from "./Repository";

const ADD_DOMAIN = "add";
const GET_SINGLE = "getSingle";
const SCAN_DNS = "scanDNSRecord";
const CHECK_DATA = "checkData";

export default {
  addDomain(payload) {
    return Repository.post(transformRoute(ADD_DOMAIN), payload);
  },
  getDNSRecord(payload) {
    return Repository.post(transformRoute(GET_SINGLE), payload);
  },
  scanDNS(payload) {
    return Repository.post(transformRoute(SCAN_DNS), payload);
  },
  checkData(payload) {
    return Repository.post(transformRoute(CHECK_DATA), payload);
  },
};

const transformRoute = (route) => {
  return `/dns/zone/${route}`;
};
